import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable, Subscription } from 'rxjs';
import { LetDirective } from '@ngrx/component';

import { CreditCard, FantazUIError } from '@fantaz/shared/data-access/models';
import { CreditCardFormModule } from '@fantaz/shared/ui/credit-card-form';
import { MaterialModule } from '@fantaz/shared/ui/material';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ActivatedRoute, Router } from '@angular/router';

type CreditCardRegisterDialogProps = {
  onSubmitCard: (card: CreditCard) => void;
  closeSignal$: Observable<boolean>;
  registerCreditCardError$: Observable<FantazUIError>;
  submitting$: Observable<boolean>;
  error$: Observable<FantazUIError>;
  initialData?: Partial<CreditCard>;
};

@UntilDestroy()
@Component({
  selector: 'fz-credit-card-register-dialog',
  standalone: true,
  imports: [CommonModule, CreditCardFormModule, LetDirective, MaterialModule],
  templateUrl: './credit-card-register-dialog.component.html',
  styleUrls: ['./credit-card-register-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreditCardRegisterDialogComponent implements OnInit, OnDestroy {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public dialogRef: MatDialogRef<CreditCardRegisterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CreditCardRegisterDialogProps,
  ) {}

  ngOnInit() {
    if (this.data.closeSignal$) {
      this.data.closeSignal$
        .pipe(untilDestroyed(this))
        .subscribe((close: boolean) => {
          if (close) {
            this.dialogRef.close({
              source: 'signal',
            });
          }
        });
    }

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { m: 'register-cc' },
      replaceUrl: true,
      queryParamsHandling: 'merge',
    });
  }

  ngOnDestroy(): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { m: null },
      replaceUrl: true,
      queryParamsHandling: 'merge',
    });
  }
  handleClose() {
    this.dialogRef.close({
      source: 'button',
    });
  }

  onClose() {
    this.dialogRef.close({
      source: 'close',
    });
  }

  onSubmitCard(card: CreditCard) {
    console.log('CreditCardRegisterDialogComponent->onSubmitCard', card);

    if (this.data.onSubmitCard) {
      this.data.onSubmitCard(card);
    }
  }
}
